module.exports = __webpack_public_path__ + "assets/img/home_ex_3.ad2e3db9.png";